import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { DateRange, GoodReport, InvoiceRecord } from '@core/services/data.service';
import { PartnersService } from '@core/services/partners.service';
import { Multilingual } from '@core/utilities/multilingual';

@Component({
  templateUrl: './initial-viewer.component.html',
  styleUrls: ['./initial-viewer.component.scss']
})
export class InitialViewerComponent implements OnInit {

  @Input()
  public range: { name: string, range: DateRange };

  @Input()
  public reports: GoodReport[];

  @Input()
  public SKU: string;

  @Input()
  public color: string;

  @Output()
  public changed = new EventEmitter<InvoiceRecord>();


  public unconfirmed(invoice: InvoiceRecord) {
    this.modal.of(this).hide();
    this.changed.emit(invoice);
  }

  public details: Filterable<GoodReport> = new Filterable<GoodReport>({
    extractor: i => [i.Path[0], this.partner(i)],
    grouper: i => [{ name: 'Nguồn nhập', option: this.partner(i).toUpperCase() }]
  });

  constructor(private partners: PartnersService, private modal: ModalService) { }

  ngOnInit(): void {

    let lu: { [key: string]: GoodReport } = {};

    this.reports.forEach(i => {
      if (!lu[i.Path[0]]) {
        lu[i.Path[0]] = { ...i };
      }
      else {
        lu[i.Path[0]].Initial.LengthCount += i.Initial.LengthCount;
        lu[i.Path[0]].Initial.LengthQuantity += i.Initial.LengthQuantity;
        lu[i.Path[0]].Initial.LengthQuoteQuantity += i.Initial.LengthQuoteQuantity;
        lu[i.Path[0]].Initial.WeightCount += i.Initial.WeightCount;
        lu[i.Path[0]].Initial.WeightQuantity += i.Initial.WeightQuantity;
        lu[i.Path[0]].Initial.WeightQuoteQuantity += i.Initial.WeightQuoteQuantity;
        lu[i.Path[0]].Initial.BaseWorth += i.Initial.BaseWorth;
        lu[i.Path[0]].Initial.QuoteWorth += i.Initial.QuoteWorth;
        lu[i.Path[0]].Initial.QuoteValue += i.Initial.QuoteValue;
      }
    })

    let source: GoodReport[] = [];

    for (let o in lu) source.push(lu[o]);

    this.details.source = source.filter(i => i.Initial.LengthCount + i.Initial.WeightCount > 0);
  }

  public partner(report: GoodReport): string {

    if (this.partners.all.length < 1) return '#';

    let partner = this.partners.get(parseInt(report.Path[0].substr(1).split('.')[0]));
    return partner ? partner.Name : Multilingual.getText('Xưởng');
  }

  public extractor(field: string): SortableExtractor<GoodReport> {
    return {
      extract: i => {
        switch (field) {
          case 'Tag': return i.Path[0];
          case 'Reduced': return i.Initial.LengthQuantity - i.Initial.LengthQuoteQuantity + i.Initial.WeightQuantity - i.Initial.WeightQuoteQuantity;
          case 'QuoteQuantity': return i.Initial.LengthQuoteQuantity + i.Initial.WeightQuoteQuantity;
          case 'ReducedLength': return i.Initial.LengthQuantity - i.Initial.LengthQuoteQuantity;
          case 'ReducedWeight': return i.Initial.WeightQuantity - i.Initial.WeightQuoteQuantity;
          case 'Price': return i.Initial.BaseWorth / (i.Initial.LengthQuoteQuantity + i.Initial.WeightQuoteQuantity);
          case 'Subtotal': return i.Initial.BaseWorth;
          default: return i.Initial[field];
        }
      }
    }
  }

  public sum(field: string): number {
    return this.details.matches.sum(i => {
      switch (field) {
        case 'ReducedLength': return i.Initial.LengthQuantity - i.Initial.LengthQuoteQuantity;
        case 'ReducedWeight': return i.Initial.WeightQuantity - i.Initial.WeightQuoteQuantity;
        case 'Subtotal': return i.Initial.BaseWorth;
        default: return i.Initial[field];
      }
    });
  }
}
